import useDeleteData from '../../../../../hooks/deleteHook';

export const useDeleteUser = () => {
  const [{ isCompleted, isLoading, isError, error }, doDelete] =
    useDeleteData();

  return { isCompleted, isLoading, isError, error, doDelete };
};
